"use client"

import clsx from "clsx"
import React, { useState } from "react"

import Button, { ButtonProps } from "@/ui/components/Button"
import LogosMarquee, { MarqueeLogoProps } from "@/ui/components/LogosMarquee"

export type MarqueeLogoSectionClientProps =
  React.ComponentPropsWithoutRef<"section"> & {
    rowsOfLogos: MarqueeLogoProps["rowsOfLogos"]
    button: ButtonProps
    hasHoverTextCta: boolean | null
  }

/**
 * Handles the presentational structure for the Logos Marquee
 */
export default function MarqueeLogoSectionClient({
  button,
  hasHoverTextCta,
  rowsOfLogos,
  ...rest
}: MarqueeLogoSectionClientProps) {
  const [isHovered, setIsHovered] = useState(false)
  const showCTAOverlay = isHovered && button && hasHoverTextCta

  return (
    <section
      {...rest}
      className={clsx(
        "marquee-logo-section-client flex flex-nowrap flex-col gap-11 lg:gap-14 xl:gap-20 pt-8 pb-10 xl:pt-18 lg:pt-20 lg:pb-28 md:py-16 relative",
        rest?.className,
      )}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* CTA Overlay */}
      {showCTAOverlay && (
        <div className="absolute inset-0 z-10 flex items-center justify-center bg-gray-0/50 backdrop-blur-sm transition-opacity duration-500">
          <Button {...button} className="p-10" />
        </div>
      )}
      <div
        className={clsx("transition duration-300", showCTAOverlay && "blur-sm")}
      >
        <LogosMarquee rowsOfLogos={rowsOfLogos} />
      </div>
    </section>
  )
}
